/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InternalValidationAuthorType = {
    System: 'SYSTEM',
    Manual: 'MANUAL'
} as const;
export type InternalValidationAuthorType = typeof InternalValidationAuthorType[keyof typeof InternalValidationAuthorType];


export function instanceOfInternalValidationAuthorType(value: any): boolean {
    for (const key in InternalValidationAuthorType) {
        if (Object.prototype.hasOwnProperty.call(InternalValidationAuthorType, key)) {
            // @ts-ignore
            if (InternalValidationAuthorType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalValidationAuthorTypeFromJSON(json: any): InternalValidationAuthorType {
    return InternalValidationAuthorTypeFromJSONTyped(json, false);
}

export function InternalValidationAuthorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalValidationAuthorType {
    return json as InternalValidationAuthorType;
}

export function InternalValidationAuthorTypeToJSON(value?: InternalValidationAuthorType | null): any {
    return value as any;
}

